import { ACTIONS_IMPORT_DATA } from '_constants/importData.constants';

const initialState = {
  byId: {},
};

export const importDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS_IMPORT_DATA.INVALIDATE: {
      return {
        ...initialState,
      };
    }

    case ACTIONS_IMPORT_DATA.RECEIVE: {
      return {
        ...state,
        byId: { ...action.byId },
      };
    }

    case ACTIONS_IMPORT_DATA.DELETE: {
      const currentByIds = { ...state.byId };
      delete currentByIds[action.id];

      return {
        ...state,
        byId: currentByIds,
      };
    }

    default:
      return state;
  }
};

export const importEntitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS_IMPORT_DATA.RECEIVE_ENTITIES: {
      return {
        ...state,
        byId: { ...action.byId },
      };
    }

    default:
      return state;
  }
};
